import React from 'react'
import { useContext } from 'react';
import { GlobalState } from '../../GlobalState';
import { useEffect } from 'react';
import { api } from '../../util/urlConfig';
import moment from 'moment';
import './supplierFeedbackNotifyComponent.css'
import { useState } from 'react';
import axios from '../../helpers/axios';

export default function InvoiceNotifyComponent({ id }) {
    const [invoiceDetail, setInvoiceDetail] = useState(null);

    const getInvoiceDetail = async (invId) => {
        const res = await axios.get(`/invoice/${invId}`);
        setInvoiceDetail(res.data.response.data);
    }

    useEffect(() => {
        getInvoiceDetail(id);
    }, [id])

    return (
        <>
            {
                invoiceDetail ?
                    <div className='notify-main-container'>
                        <div className='notify-content-area'>
                            <img className='notify-img' src={invoiceDetail.customer && invoiceDetail.customer.upload_image ? api + "/" + invoiceDetail.customer.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                            <div className='notify-content-detail'>
                                <div className='notify-name'>
                                    {
                                        invoiceDetail.customer ? invoiceDetail.customer.first_name + " " + invoiceDetail.customer.last_name : ""
                                    }
                                </div>


                                <div className='notify-subname'>You have purchased Rs. {invoiceDetail.net_price}. Thank you.</div>
                                <div className='notify-subname'>
                                    <i className='uil uil-clock'></i>
                                    <span>{moment(invoiceDetail.created_at).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}
